import { render, staticRenderFns } from "./VideoCallCNTT.vue?vue&type=template&id=f4d9406e&scoped=true"
import script from "./VideoCallCNTT.vue?vue&type=script&lang=js"
export * from "./VideoCallCNTT.vue?vue&type=script&lang=js"
import style0 from "./VideoCallCNTT.vue?vue&type=style&index=0&id=f4d9406e&prod&scoped=true&lang=scss"
import style1 from "./VideoCallCNTT.vue?vue&type=style&index=1&id=f4d9406e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4d9406e",
  null
  
)

export default component.exports